module.exports = __WEBPACK_EXTERNAL_MODULE_38__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/BehaviorSubject"
// module id = 38
// module chunks = 0